import type { HTMLProps } from "react";
import { forwardRef } from "react";
import classNames from "classnames";
import Radio from "../Radio/Radio";
import styles from "./RadioCard.module.scss";

type RadioCardProps = {
  title: string;
  description: string;
} & HTMLProps<HTMLInputElement>;

const RadioCard = forwardRef<HTMLInputElement, RadioCardProps>(
  function RadioCard({ title, description, className, ...rest }, ref) {
    return (
      <label
        className={classNames(styles.card, className, {
          [styles.cardChecked]: rest.checked,
        })}
        htmlFor={rest.id}
      >
        <div>
          <p className={styles.title}>{title}</p>
          <p className={styles.description}>{description}</p>
        </div>
        <Radio {...rest} className={styles.radio} ref={ref} />
      </label>
    );
  },
);

export default RadioCard;
